import { Component, Inject } from '@angular/core';
import { MatDatepicker, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import * as moment from 'moment-timezone';
import { Toaster, Type } from '../../../../../../toaster/Toaster';
import { LrsFrequency } from '../../../../../../model/finzy-flex/lrs-list.model';
import { AccountService } from '../../../../../../service/finzy-flex/account/account.service';
import { StorageService, Keys } from '../../../../../../../app/service/storage.service';

@Component({
    selector: 'app-lrs-download-popup',
    templateUrl: './lrs-download-popup.component.html',
    styleUrls: ['./lrs-download-popup.component.scss']
})

export class LrsDownloadPopupComponent {
    private matDialogRef: MatDialogRef<LrsDownloadPopupComponent>;
    private accountService: AccountService;
    private lenderId: string;
    public selectedFromDate: Date;
    public selectedToDate: Date;
    public selectedProductType: string;
    public productTypes: string[];
    private readonly storageService: StorageService;
    constructor(
        matDialogRef: MatDialogRef<LrsDownloadPopupComponent>,
        accountService: AccountService,
        storageService: StorageService, 
        @Inject(MAT_DIALOG_DATA) data: {
            lenderId: string,
            productTypes: [],
        },
    ) {
        this.matDialogRef = matDialogRef;
        this.accountService = accountService;
        this.storageService = storageService;
        this.lenderId = data.lenderId;
        const sortAlphaNum = (currentData, nextData) => currentData.localeCompare(nextData, 'en', { numeric: true })
        this.productTypes = data.productTypes.sort(sortAlphaNum);

    }

    public async onDownload() {
        if ((this.selectedFromDate && this.selectedToDate && (moment(this.selectedFromDate).isSameOrBefore(this.selectedToDate)))) {
            const fromDate = moment(this.selectedFromDate).format('YYYY/MM/DD');
            const toDate = moment(this.selectedToDate).format('YYYY/MM/DD');
            const generatedUserId = this.storageService.getItem(Keys.GENERATED_USER_ID);
            const lrsReportFile = await this.accountService.downloadLrs(this.lenderId, fromDate, toDate, LrsFrequency.DAILY , this.selectedProductType);
            let downloadUrl = URL.createObjectURL(lrsReportFile);
            let downloadElem = document.createElement('a');
            downloadElem.href = downloadUrl;
            downloadElem.download = generatedUserId + '_IRSData_' + moment().format('DD_MMM_YYYY') + '.xlsx';
            downloadElem.click();
            this.onClose();
        } else {
            Toaster.toast('Please choose the correct date range', Type.Error);
        }
    }

    public async selectMonthAndYear(dateType: 'startDate' | 'endDate' ,inputDate: Date, datepicker: MatDatepicker<any>) {
        if (dateType == 'startDate') {
            this.selectedFromDate = moment(inputDate).startOf('month').toDate();
        }
        if (dateType == 'endDate') {
            this.selectedToDate = moment(inputDate).endOf('month').toDate();
        }
        datepicker.close();
    }

    public selectProductType() {
        if (this.selectedProductType == 'selectType') {
            this.selectedProductType = undefined;
        }
    }

    public onClose() {
        return this.matDialogRef.close();
    }
}